import * as React from 'react'

import { withErrorPage } from '@grandvisionhq/next'
import { compose } from '@grandvisionhq/utils'

import { withCms, withLayout } from '../../cms'
import { defaultErrorProps } from '../error-props'
import { withCart } from './with-cart'

export function composePDP<T>(PDP: React.FunctionComponent<T>) {
  return compose<T, T>(
    withCms(),
    withErrorPage(defaultErrorProps),
    withLayout(),
    withCart({ readOnly: true })
  )(PDP)
}
